var render = function render(){var _vm=this,_c=_vm._self._c;return _c('issue-card-time-info',{attrs:{"issue":_vm.issue}},[_c('weight-count',{staticClass:"issuable-weight gl-mr-3",attrs:{"weight":_vm.weight,"data-testid":"issuable-weight-content"}}),_vm._v(" "),(_vm.showHealthStatus)?_c('issue-health-status',{attrs:{"health-status":_vm.healthStatus}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }